import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { ErrorRoutingModule } from "./error-routing.module";
import { ErrorNotFoundComponent } from "./page/not-found/not-found.component";
import { ErrorNotAuthorizedComponent } from "./page/not-authorized/not-authorized.component";
import { ErrorServerFailureComponent } from "./page/server-failure/server-failure.component";


@NgModule({
  declarations: [
    ErrorNotFoundComponent,
    ErrorNotAuthorizedComponent,
    ErrorServerFailureComponent,
  ],
  imports: [
    CommonModule,
    ErrorRoutingModule
  ]
})
export class ErrorModule { }
